import { prefersReducedMotion } from '@theme/utilities';

const STORAGE_KEY = 'theme:page-entrance';
const READY_CLASS = 'page-entrance--ready';
const VISIBLE_CLASS = 'page-entrance--visible';

/**
 * Soft page entrance after internal navigations.
 * Replaces cross-document View Transitions for general page loads.
 */
class PageEntrance {
  constructor() {
    const effect = document.documentElement.dataset.pageEntrance;
    if (!effect || effect === 'none') return;

    this.#armInternalLinks(effect);
    this.#playIfNeeded(effect);
  }

  /**
   * @param {string} effect
   */
  #armInternalLinks(effect) {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const link = target.closest('a[href]');
        if (!(link instanceof HTMLAnchorElement)) return;
        if (link.target === '_blank' || link.hasAttribute('download')) return;
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        let url;
        try {
          url = new URL(link.href, window.location.origin);
        } catch {
          return;
        }

        if (url.origin !== window.location.origin) return;
        if (url.pathname === window.location.pathname && url.search === window.location.search) return;
        if (url.pathname.startsWith('/cart') || url.pathname.startsWith('/checkout')) return;

        try {
          sessionStorage.setItem(STORAGE_KEY, effect);
        } catch {
          // Ignore storage failures.
        }
      },
      { capture: true }
    );
  }

  /**
   * @param {string} effect
   */
  #playIfNeeded(effect) {
    let stored = null;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      return;
    }

    if (!stored || prefersReducedMotion()) {
      document.documentElement.classList.remove('page-entrance-pending');
      return;
    }

    const main = document.getElementById('MainContent');
    if (!main) {
      document.documentElement.classList.remove('page-entrance-pending');
      return;
    }

    main.dataset.pageEntranceEffect = stored || effect;
    main.classList.add(READY_CLASS);
    document.documentElement.classList.remove('page-entrance-pending');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        main.classList.add(VISIBLE_CLASS);
      });
    });
  }
}

new PageEntrance();
